import React, { useState, useEffect } from "react";
import { Box } from "grommet";
import { faUserKey } from "@fortawesome/pro-light-svg-icons";
import FontAwesomeIcon from "./FontAwesomeIcon";
import Button from "./Button";
import { passkeyClient, isPasskeySupported } from "../lib/passkey-client";

/**
 * PasskeyLoginButton - Button to initiate passkey authentication
 * Used on the signin page as an alternative to password login
 */
const PasskeyLoginButton = ({ onSuccess, onError, email, callbackUrl = "/" }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSupported, setIsSupported] = useState(false);

    useEffect(() => {
        setIsSupported(isPasskeySupported());
    }, []);

    const handlePasskeyLogin = async () => {
        try {
            setIsLoading(true);
            const result = await passkeyClient.authenticateWithPasskey(email, {
                redirect: false,
                callbackUrl,
            });

            if (result.ok) {
                onSuccess?.();
            } else {
                onError?.(result.error);
            }
        } catch (error) {
            onError?.(error.message || 'Passkey authentication failed');
        } finally {
            setIsLoading(false);
        }
    };

    if (!isSupported) {
        return null;
    }

    return (
        <Box>
            <Button
                secondary
                label={isLoading ? "Authenticating..." : "Log in with Passkey"}
                onClick={handlePasskeyLogin}
                disabled={isLoading}
                icon={<FontAwesomeIcon size="xsmall" icon={faUserKey} />}
                event={{ section: 'sign_in_form', element: 'passkey_login' }}
            />
        </Box>
    );
};

export default PasskeyLoginButton;
